var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNoteYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24512 11.3333H18.9118V14H4.24512V11.3333ZM4.24512 8.66667H18.9118V6H4.24512V8.66667ZM4.24512 19.3333H13.5785V16.6667H4.24512V19.3333ZM24.2585 15.16L25.2051 14.2133C25.7251 13.6933 26.5651 13.6933 27.0851 14.2133L28.0318 15.16C28.5518 15.68 28.5518 16.52 28.0318 17.04L27.0851 17.9867L24.2585 15.16ZM23.3118 16.1067L16.2451 23.1733V26H19.0718L26.1385 18.9333L23.3118 16.1067Z",
    fill: "#EAC176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoteYellow);
export default __webpack_public_path__ + "static/media/edit_note_yellow.422bc7abfd4c293a8c01b283111cabfb.svg";
export { ForwardRef as ReactComponent };